import config from '../config.json'
import api from '@/api'

// import _ from 'lodash'
const allHeaders = config.tab_settings.patient.tableHeader.concat(
  config.tab_settings.medication.tableHeader,
  config.tab_settings.comorbidity.tableHeader,
  config.exudats.proliferation.tableHeader,
  config.exudats.compound.tableHeader,
  config.exudats.ha.tableHeader,
  config.exudats.gf.tableHeader,
  config.exudats.we.tableHeader
)
const compoundHeaders = [
  { 'label': 'Patient pseudonym', 'db_key': 'patient_id', 'input_type': 'String', 'visible': false },
  { 'label': 'exudate #', 'db_key': 'exudate', 'input_type': 'String', 'visible': true },
  { 'label': 'Cell type', 'db_key': 'cell_type', 'input_type': 'String', 'visible': true },
  { 'label': 'Readout', 'db_key': 'readout', 'input_type': 'String', 'visible': true },
  { 'label': 'WE concentration (%)', 'db_key': 'we_concentration', 'input_type': 'Number', 'visible': false },
  { 'label': 'Compound', 'db_key': 'compound', 'input_type': 'String', 'visible': true },
  { 'label': 'concentration: 30000', 'db_key': 'concentration_30000', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 10000', 'db_key': 'concentration_10000', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 3000', 'db_key': 'concentration_3000', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 1000', 'db_key': 'concentration_1000', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 300', 'db_key': 'concentration_300', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 200', 'db_key': 'concentration_200', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 100', 'db_key': 'concentration_100', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 30', 'db_key': 'concentration_30', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 20', 'db_key': 'concentration_20', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 10', 'db_key': 'concentration_10', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 5', 'db_key': 'concentration_5', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 3', 'db_key': 'concentration_3', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 2', 'db_key': 'concentration_2', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 1', 'db_key': 'concentration_1', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 0.5', 'db_key': 'concentration_05', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 0.3', 'db_key': 'concentration_03', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 0.2', 'db_key': 'concentration_02', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 0.1', 'db_key': 'concentration_01', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 0.02', 'db_key': 'concentration_002', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' },
  { 'label': 'concentration: 0', 'db_key': 'concentration_0', 'input_type': 'Number', 'visible': true, 'category': 'Concentration' },
  { 'label': 'growth factor', 'db_key': 'growth_factor', 'input_type': 'String', 'visible': true },
  { 'label': 'Max. Stimulation', 'db_key': 'max_stimulation', 'input_type': 'Number', 'visible': true },
  { 'label': 'ED50', 'db_key': 'ed_50', 'input_type': 'String', 'visible': false },
  { 'label': 'Max. Inhibition', 'db_key': 'max_inhibition', 'input_type': 'Number', 'visible': false },
  { 'label': 'IC50', 'db_key': 'ic_50', 'input_type': 'String', 'visible': false },
  { 'label': 'Unit', 'db_key': 'unit', 'input_type': 'String', 'visible': false },
  { 'label': 'Exp. #', 'db_key': 'exp', 'input_type': 'String', 'visible': true },
  { 'label': 'Comments', 'db_key': 'comment', 'input_type': 'String', 'visible': false }
]

const helpers = {
  allHeaders,
  compoundHeaders,
  getName (item) {
    return item.day_id || item.exudate || item.patient_id || item.option
  },
  replaceSpecialLetters (str) {
    return (typeof str === 'string') ? str.replace(/ä/gi, 'ae').replace(/ö/gi, 'oe').replace(/ü/gi, 'ue').replace(/ß/gi, 'ss') : null
  },
  getAssociationName (str) {
    var returnStr = (str.slice(-1) === 'y') ? str.slice(0, -1) + 'ie' : str
    return returnStr.toLowerCase() + 's'
  },
  capitalizeFirstLetter (str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  },
  getPostResource (route) {
    if (route.name === 'properties') {
      return route.params.db_id
    } else if (route.name === 'trash') {
      return `trash-${route.params.table}`
    } else if (route.path.includes('exudats')) {
      return `exudats/${route.params.experiment}`
    } else {
      return route.name
    }
  },
  getFilterType (inputType) {
    return (['Boolean', 'Date', 'ComputedDate', 'Array', 'Number', 'ComputedNumber'].includes(inputType)) ? inputType : 'FreeText'
  },
  columnIsVisible (columns, key, visible, medFilter) {
    var config1 = columns[key]
    var config2 = columns[this.getAssociationName(key)]
    if (medFilter && medFilter[key]) {
      return true
    } else if (typeof config1 !== 'undefined') {
      return config1
    } else if (typeof config2 !== 'undefined') {
      return config2
    } else {
      return visible
    }
  },
  compoundToUnit: {
    compound: 'nM',
    ha: '%',
    gf: 'ng/ml'
  },
  getPlural (str) {
    return (str.slice(-1) === 'y') ? str.slice(0, -1) + 'ies' : str + 's'
  },
  germanToEnglish (config) {
    config = (config) ? config.tableHeader : allHeaders
    var transDict = {}
    config.forEach(head => {
      transDict[head.label] = head.db_key
      transDict[this.replaceSpecialLetters(head.label)] = head.db_key
    })
    return transDict
  },
  englishToGerman (config) {
    config = (config) ? config.tableHeader : allHeaders
    var transDict = {}
    config.forEach(head => {
      transDict[head.db_key] = head.label
      transDict[this.getPlural(head.db_key.toLowerCase())] = head.label
    })
    return transDict
  },
  transformDBToTable (dbData) {
    var transformedData = dbData.map(function (row) {
      var transformedRow = JSON.parse(JSON.stringify(row))
      transformedRow.substances.forEach((substance, sIndex) => {
        transformedRow[`wirkstoff_${sIndex + 1}`] = substance.substance
        substance.moas.forEach((moa, mIndex) => {
          transformedRow[`moa_${sIndex + 1}_${mIndex + 1}`] = moa.moa
        })
      })
      transformedRow.effects.forEach((effect, index) => {
        transformedRow[`therapeutischer_effekt_${index + 1}`] = effect.effect
      })
      delete transformedRow.substances
      delete transformedRow.effects
      return transformedRow
    })
    return transformedData
  },
  createUploadFeedback (response) {
    response = (Array.isArray(response)) ? response : [response]
    var errorObjects = response.filter(el => el.err)
    if (errorObjects.length) {
      var errorText = 'Probleme beim Upload der Einträge:'
      errorObjects.forEach(obj => {
        try {
          errorText += `\n\n Fehlerhafte Eingabe in Spalte ${obj.day_id || obj.patient_id || obj.option}`
          console.log(obj)
          // \n (Hinweis: ${obj.err.split(':').slice(-2).join(':')})
        } catch (err) {
          errorText += `\n ${obj}`
        }
      })
      alert(errorText)
    }
    var successObjects = response.filter(el => el && !el.err)
    if (successObjects.length) {
      // Feedback about newly uploaded objects
      var uploadedObjects = successObjects.filter(el => el && el.created).map(el => el.result.day_id || el.result.exudate || el.result.patient_id || el.result.option || el.result.id + '')
      this.feedbackAlert(uploadedObjects, 'Erfolgreich hochgeladen')

      // Feedback about already existing objects
      var existingObjects = successObjects.filter(el => el && !el.created)
      if (existingObjects.length) {
        if (existingObjects[0].result) { // Objects were found and left
          var notChangedObjects = existingObjects.map(el => el.result.day_id || el.result.exudate || el.result.patient_id || el.result.option || el.result.id + '')
          this.feedbackAlert(notChangedObjects, 'Nicht hochgeladen, da bereits vorhanden')
        } else { // Objects were edited
          var editedObjects = existingObjects.map(el => el.day_id || el.exudate || el.patient_id || el.option || el.result.id + '')
          this.feedbackAlert(editedObjects, 'Erfolgreich geändert')
        }
      }
    }
  },
  async canBeDeleted (item, route, giveAlert) {
    if (route.name === 'properties') {
      var patients = await api.getPatientsToAssoc(route.params.db_id, item)
      if (patients.length === 1) {
        if (giveAlert) alert('Dieser Eintrag kann nicht gelöscht werden, da er bei Patient ' + patients.map(pat => pat.day_id) + ' verwendet wird.')
      } else if (patients.length) {
        if (giveAlert) alert('Dieser Eintrag kann nicht gelöscht werden, da er bei den Patienten ' + patients.map(pat => pat.day_id).join(', ') + ' verwendet wird.')
      } else {
        return true
      }
      return false
    } else {
      return true
    }
  },
  augmentRow (row) {
    var medicArray = row.medication
    var substances = []
    var effects = []
    var moas = []
    medicArray.forEach(medic => {
      var newSubstances = medic.substances && medic.substances.map(sub => sub.substance)
      substances = substances.concat(newSubstances)
      medic.substances && medic.substances.forEach(sub => {
        var newMoas = sub.moas && sub.moas.map(moa => moa.moa)
        moas = moas.concat(newMoas)
      })
      var newEffects = medic.effects && medic.effects.map(eff => eff.effect)
      effects = effects.concat(newEffects)
    })
    row.substance = [...new Set(substances)].join(', ')
    row.moa = [...new Set(moas)].join(', ')
    row.effect = [...new Set(effects)].join(', ')
    return row
  },
  feedbackAlert (objArray, message) {
    objArray = objArray.filter(el => el && el.length) // Don't display empty strings
    if (objArray.length === 1) {
      alert(`${message}: ${objArray[0]}`)
    } else if (objArray.length) {
      alert(`${message}: ${objArray.join(', ')}`)
    }
  }
}

export default helpers



// WEBPACK FOOTER //
// ./src/mixins/helper-functions.js